

/* eslint no-useless-escape: 0 */
// app.validator
(function (app, $) {
	var naPhone = new RegExp(app.resources.REGEXP_PHONE),
		regex = {
			phone: {
				// Default phone regex
				df: new RegExp(app.resources.REGEXP_DFLTPHONE),
				// Countries phone
				us: naPhone,
				ca: naPhone,
				cn: new RegExp(app.resources.REGEXP_CN_PHONE),
				de: new RegExp(app.resources.REGEXP_DE_PHONE),
				gb: new RegExp(app.resources.REGEXP_GB_PHONE),
				uk: new RegExp(app.resources.REGEXP_GB_PHONE),
				fr: new RegExp(app.resources.REGEXP_FR_PHONE),
				pl: new RegExp(app.resources.REGEXP_PL_PHONE),
				cz: new RegExp(app.resources.REGEXP_CZ_PHONE),
				it: new RegExp(app.resources.REGEXP_IT_PHONE),
				es: new RegExp(app.resources.REGEXP_ES_PHONE),
				at: new RegExp(app.resources.REGEXP_AT_PHONE),
				ch: new RegExp(app.resources.REGEXP_CH_PHONE),
				be: new RegExp(app.resources.REGEXP_BE_PHONE),
				nl: new RegExp(app.resources.REGEXP_NL_PHONE),
				dk: new RegExp(app.resources.REGEXP_DK_PHONE),
				se: new RegExp(app.resources.REGEXP_SE_PHONE),
				no: new RegExp(app.resources.REGEXP_NO_PHONE),
				fi: new RegExp(app.resources.REGEXP_FI_PHONE)
			},
			postal: {
				us: new RegExp(app.resources.REGEXP_US_ZIP),
				ca: new RegExp(app.resources.REGEXP_CA_ZIP),
				gb: new RegExp(app.resources.REGEXP_GB_ZIP),
				uk: new RegExp(app.resources.REGEXP_GB_ZIP),
				br: new RegExp(app.resources.REGEXP_BR_ZIP),
				de: new RegExp(app.resources.REGEXP_DE_ZIP),
				cn: new RegExp(app.resources.REGEXP_CN_ZIP),
				sg: new RegExp(app.resources.REGEXP_SG_ZIP),
				au: new RegExp(app.resources.REGEXP_AU_ZIP),
				pl: new RegExp(app.resources.REGEXP_PL_ZIP),
				cz: new RegExp(app.resources.REGEXP_CZ_ZIP),
				fr: new RegExp(app.resources.REGEXP_FR_ZIP),
				es: new RegExp(app.resources.REGEXP_ES_ZIP),
				it: new RegExp(app.resources.REGEXP_IT_ZIP),
				be: new RegExp(app.resources.REGEXP_BE_ZIP),
				nl: new RegExp(app.resources.REGEXP_NL_ZIP),
				ch: new RegExp(app.resources.REGEXP_CH_ZIP),
				dk: new RegExp(app.resources.REGEXP_DK_ZIP),
				se: new RegExp(app.resources.REGEXP_SE_ZIP),
				no: new RegExp(app.resources.REGEXP_NO_ZIP),
				fi: new RegExp(app.resources.REGEXP_FI_ZIP),
				at: new RegExp(app.resources.REGEXP_AT_ZIP)
			},

			excludedpostal: {
				us: new RegExp(app.resources.REGEXP_US_EXCLUDED_ZIP),
				ca: new RegExp(app.resources.REGEXP_CA_EXCLUDED_ZIP),
				gb: new RegExp(app.resources.REGEXP_GB_EXCLUDED_ZIP),
				uk: new RegExp(app.resources.REGEXP_GB_EXCLUDED_ZIP),
				br: new RegExp(app.resources.REGEXP_BR_EXCLUDED_ZIP),
				de: new RegExp(app.resources.REGEXP_DE_EXCLUDED_ZIP),
				cn: new RegExp(app.resources.REGEXP_CN_EXCLUDED_ZIP),
				sg: new RegExp(app.resources.REGEXP_SG_EXCLUDED_ZIP),
				au: new RegExp(app.resources.REGEXP_AU_EXCLUDED_ZIP),
				pl: new RegExp(app.resources.REGEXP_PL_EXCLUDED_ZIP),
				cz: new RegExp(app.resources.REGEXP_CZ_EXCLUDED_ZIP),
				fr: new RegExp(app.resources.REGEXP_FR_EXCLUDED_ZIP),
				es: new RegExp(app.resources.REGEXP_ES_EXCLUDED_ZIP),
				it: new RegExp(app.resources.REGEXP_IT_EXCLUDED_ZIP),
				be: new RegExp(app.resources.REGEXP_BE_EXCLUDED_ZIP),
				nl: new RegExp(app.resources.REGEXP_NL_EXCLUDED_ZIP),
				ch: new RegExp(app.resources.REGEXP_CH_EXCLUDED_ZIP),
				dk: new RegExp(app.resources.REGEXP_DK_EXCLUDED_ZIP),
				se: new RegExp(app.resources.REGEXP_SE_EXCLUDED_ZIP),
				no: new RegExp(app.resources.REGEXP_NO_EXCLUDED_ZIP),
				fi: new RegExp(app.resources.REGEXP_FI_EXCLUDED_ZIP),
				at: new RegExp(app.resources.REGEXP_AT_EXCLUDED_ZIP)
			},

			creditcards: {
				creditcard:	new RegExp(app.resources.REGEXP_CREDITCARD),
				visa:		new RegExp(app.resources.REGEXP_VISA),
				master:		new RegExp(app.resources.REGEXP_MASTER),
				amex:		new RegExp(app.resources.REGEXP_AMEX),
				discover:	new RegExp(app.resources.REGEXP_DISCOVER),
				maestro:	new RegExp(app.resources.REGEXP_MAESTRO),
				dankort:	new RegExp(app.resources.REGEXP_DANKORT)
			},

			address: {
				// Default address regex
				df: new RegExp(app.resources.REGEXP_ADDRESS),
				// Countries address
				gr:	new RegExp(app.resources.REGEXP_GR_ADDRESS)
			},
			
			message: {
				df: new RegExp(app.resources.REGEXP_MESSAGE),
				gr:	new RegExp(app.resources.REGEXP_GR_MESSAGE)
			},
			
			city: {
				df: new RegExp(app.resources.REGEXP_CITY),
				gr: new RegExp(app.resources.REGEXP_GR_CITY)
			},

			password: new RegExp(app.resources.REGEXP_PASSWORD),
			email: new RegExp(app.resources.REGEXP_EMAIL),
			nospecchars: new RegExp(app.resources.REGEXP_NO_SPECIAL_CHARACTERS),
			giftmessage: /^[\u0001-\u00FF]+$/,
			controlchar: /[\u0000-\u001F]/g,
			properNoun : new RegExp(app.resources.REGEXP_NOUN),
			streetNb : new RegExp(app.resources.REGEXP_STREETNB),
			birthDate : new RegExp(app.resources.REGEXP_BIRTHDAY)
		},
		
		settings = {
			// Birthdate uses a hidden field to compute the date, on which validation needs to be done
			ignore : '.ignore, :hidden:not(.birthDate, .shipping-fields textarea, input[id$="_pickupStoreID"], input[type="checkbox"].required)',
			errorClass: 'error-message',
			errorElement: 'span',
			onkeyup: false,
			onfocusout: function (element) {
				if(!this.checkable(element)) {
					if (this.element(element) === true) {
						$(element).closest('.form-row').removeClass('error-container');
					} else {
						$(element).closest('.form-row').addClass('error-container');
					}
				}
			},
			invalidHandler : function(event, validator) {
				for(err in validator.errorList) {
					if($(".shipping-fields input, .shipping-fields textarea").is(validator.errorList[err].element)) {
						// If one of the current field in error is one of the input fields inside the shipping-fields area
						// Slide the form to reveal the fields
						$("div.shipping-fields").slideDown()
						break;
					}
				}
				
				for(var i=0;i<validator.errorList.length;i++) {
					if(typeof dataLayer !== 'undefined') {
						var attr = $(validator.currentForm).attr('id');
						var attrValue = (typeof attr !== typeof undefined && attr !== false) ? attr : 'form';
						$(document).trigger("form.error",[attrValue, validator.errorList[i].message]);
					}
					$(validator.errorList[i].element).closest('.form-row').addClass('error-container'); 
				}
			},
			success: function(label, element){
				var parent = $(element).closest('.form-row');
				var form = $('form.checkout-shipping, form.checkout-billing, form#RegistrationForm,form#EasyRegister, form#dwfrm_login, form#dwfrm_ordertrack_findorder');
				if (form.length){
					label.addClass('valid');
					// Only display the valid check if the form uses it
					if(form.hasClass('display-check') && !$(element).is("input[type=checkbox]")  && !form.validate().optional(element)) {
						label.text(' ✔ ');
					}
					
					// call avatax for US sites
					if(element.classList.contains("zip") && element.classList.contains("avataxValidation")) {
					                        
						// This method is declarad in Sandro.js and Maje.js in order to refactoring code
					    Common.validator.refreshCartAmounts(element.value);
					}
				}
			},
			errorPlacement: function(error, element) {
				
				var formElement = $(element).parents("form");
				var formElementId = $(formElement).length > 0 && $(formElement).attr("id") !== "" ? $(formElement).attr("id") : "form";
				var errorMessage = $(error).text();
				
				$(document).trigger("form.error",[formElementId, errorMessage]);
				
				// If the field is followed by a caption, put the error befor the caption, else put it last in the form-row div
				var parent = $(element).closest('.form-row');
				var caption = parent.find('.form-caption');

				/*** Special cases of error placements ***/
				// Mostly for Sandro, avoid breaking document flow when displaying an error after a caption
				if(caption.length) {
					caption.before(error);
					caption.hide();
					return;
				}

				// On all brands, corrects error placement for registered credit cards'cvn
				if($("input[id*='creditCard_cvn']").is(element)) {
					$(element).after(error);
					return;
				}

				if($(element).is('input[id$="_pickupStoreID"]')){
					$('div.location-search').append(error);
					return;
				}

				/*** General case ***/
				parent.append(error);
			},
			groups: {
				// Grouping credit card expiry date fields
				dateExpired: 'dwfrm_billing_paymentMethods_creditCard_month dwfrm_billing_paymentMethods_creditCard_year'
			}
		};

	// If patterns are overridden in site prefs, change them here
	if (app.siteprefs && app.siteprefs.FORMSPATTERNS) {
		$.extend(true, regex, app.siteprefs.FORMSPATTERNS);
	}

	/**
	 * @function
	 * @description Retrieve the field in this specific part of the form in case there are multiple country field in the form
	 * @param {String} attrValue The name attribute of the country field
	 *
	 */
	function getAddressTypeMarker(attrValue) {
		var res = /(billing|shipping|profile)/.exec(attrValue);
		if (res) {
			return res[0];
		}
		return null;
	}

	/*////////////////// VALIDATION FUNCTIONS //////////////////*/

	function validateCountry(value, el) {
		return (value != "" && value != null);
	}

	function validatePhone(value, el) {
		if (this.optional(el)) {
			return true;
		}
		var $input = $(el),
			$newslettercheck = $('.NewsletterSMSCheck');
		// smcp custom data-pattern
		if ($input.data('pattern')) {
			var patt = new RegExp($input.data('pattern'));
			$("button.get-code, input[id*='_phoneverificationcode']").prop("disabled", !patt.test(value));
			return patt.test(value);
		}
		/** Enable disable newsletter checkbox **/
		if ($newslettercheck.length) {
			$input.blur(function(){
				if( $(this).val() && !$(this).hasClass('error-message') ) {
					$newslettercheck.prop('disabled', false);
				} else {
					$newslettercheck.prop('disabled', true);
					$newslettercheck.prop('checked', false);
				}
			});
		}
		var $country = $input.closest('fieldset').find('.country:input');
		if ($country.length > 1) {
			var addrType = getAddressTypeMarker($input.attr('name'));
			$country = $country.filter("[name*='" + addrType + "']");
		}
		var country = ($country.length === 1) ? $country.val() : null;
		country = country && country.toLowerCase();
		return (regex.phone[country] || regex.phone['df']).test(value);
	}

	/**
	 * @function
	 * @description Validates a given noun
	 * @param {String} value The noun which will be validated
	 * @param {String} el The input field
	 */
	function validateNoun(value, el) {
		var isOptional = this.optional(el);
		var isValid = regex.properNoun.test($.trim(value));
		return isOptional || isValid;
	}

	/**
	 * @function
	 * @description Validates a given birthDate
	 * @param {String} value The birthdate which will be validated (does not really make sense here but kept for compatibility)
	 * @param {String} el The input field
	 */
	function validateBirthday(value, el) {
		var isOptional = this.optional(el);
		var isValid = false;

		var dateElmts = value.split('/');

		// Put the elements back in order
		var date = new Date(dateElmts[2]+'/'+dateElmts[1]+'/'+dateElmts[0]);
		
		// We want the field to be valid only if all fields are correctly filled
		if(regex.birthDate.test(value) && date < (new Date())) {
			isValid = true;
		}

		return isOptional || isValid;
	}

	function validateStreetNb(value, el) {
		var isOptional = this.optional(el);
		var isValid = regex.streetNb.test($.trim(value));
		return isOptional || isValid;
	}

	function validateAddress(value, el) {
		var isOptional = this.optional(el);
		var isValid = false;
		var $country = $(el).closest('fieldset').find('.country:input');
		var country = ($country.length === 1) ? $country.val() : null;
		
		country = country && country.toLowerCase();
		if(regex.address[country]){
			isValid = regex.address[country].test($.trim(value));
		} else {
			isValid = regex.address['df'].test($.trim(value));
		}
		return isOptional || isValid;
	}
	
	
	function validateMessage(value, el) {
		var isOptional = this.optional(el);
		var isValid = false;
		var $country = $(el).closest('fieldset').find('.country:input');
		var country = ($country.length === 1) ? $country.val() : null;
		
		country = country && country.toLowerCase();
		if(regex.message[country]){
			isValid = regex.message[country].test($.trim(value));
		} else {
			isValid = regex.message['df'].test($.trim(value));
		}
		return isOptional || isValid;
	}

	function validateZip(value, el) {
		var $input = $(el),
			$country = $input.closest('form').find('.country:input');
		if ($country.length > 1) {
			var addrType = getAddressTypeMarker($input.attr('name'));
			$country = $country.filter("[name*='" + addrType + "']");
		}
		var countryCode = $input.data('validationCountryCode') || $country.val();

		if (!countryCode || !regex.postal[countryCode.toLowerCase()] || !regex.excludedpostal[countryCode.toLowerCase()]) return true;

		if (value && app.constants.GB_ZIP_TO_UPPER && /^gb$/i.test(countryCode)) {
			value = value.toUpperCase();
			$input.val(value);
		}

		var isOptional = this.optional(el),
			rgx,
			isValid;

		if (regex.postal[countryCode.toLowerCase()]) {
			rgx = regex.postal[countryCode.toLowerCase()];
			isValid = rgx.test($.trim(value));
			if (isValid == false) {
				$.validator.messages.zip = app.resources.INVALID_ZIP;
			}
		}

		if (isValid == true && regex.excludedpostal[countryCode.toLowerCase()] && regex.excludedpostal[countryCode.toLowerCase()].toString() != '/(?:)/') {
			rgx = regex.excludedpostal[countryCode.toLowerCase()];
			isValid = rgx.test($.trim(value));
			if (isValid == false) {
				$.validator.messages.zip = app.resources.EXCLUDED_ZIP;
			}
		}

		return isOptional || isValid;
	}

	function validateCity(value, el) {
		var isOptional = this.optional(el);
		var isValid = false;
		var $country = $(el).closest('fieldset').find('.country:input');
		var country = ($country.length === 1) ? $country.val() : null;
		
		country = country && country.toLowerCase();
		if(regex.address[country]){
			isValid = regex.city[country].test($.trim(value));
		} else {
			isValid = regex.city['df'].test($.trim(value));
		}
		return isOptional || isValid;
	}
		
	function validateEmail(value, el) {
		var isOptional = this.optional(el);
		var isValid = regex.email.test($.trim(value));
		return isOptional || isValid;
	}

	function validateSameEmail(value, el) {
		return $('#' + $(el).data('match-input')).val() == value;
	}

	function validatePassword(value, el) {
		var isOptional = this.optional(el);
		var isValid = regex.password.test($.trim(value));
		return isOptional || isValid;
	}

	function validateSamePassword(value, el) {
		return $('#' + $(el).data('match-input')).val() == value;
	}

	function validateCreditCard(value) {
		/*var typeCard = $('input[#ccard-type-container]:checked').val();
		var isValid = true;
		if(typeCard.length > 0 && typeof regex.creditcards[typeCard.toLowerCase()] !== 'undefined') {			
			isValid = regex.creditcards[typeCard.toLowerCase()].test(value);
		}
		return isValid;*/
		return true;
		
		//return isValid;
		
	}

	function validateGiftMessage(value, el){
		var isValid = true;
		if($("input[name$='_addGiftMessage']:checked").length >0 && value.length <= 0){
			 isValid = false;
		}
		return isValid;
	}

	function validateGiftAmount(value, el){
		var isOptional = this.optional(el);
		var isValid = (!isNaN(value)) && (parseFloat(value)>=5) && (parseFloat(value)<=5000);
		return isOptional || isValid;
	}

	function validateExpiryDate(value, el){
		var today, expiryDate, isValid = true;
		var monthField = $("[name$='_paymentMethods_creditCard_month']:input"),
		    yearField = $("[name$='_paymentMethods_creditCard_year']:input");
		var exMonth = monthField.val();
		var exYear  = yearField.val();

		if(!exMonth || !exYear || isNaN(exMonth) || isNaN(exYear)) return false;

		today = new Date();
		// A bit complicated, but returns the last day of the month for the given expiry date
		// by getting the first day of the next month, converting to timestamp, and removing a day's worth in seconds
		expiryDate = new Date( (new Date(exYear, exMonth, 1)).getTime() - 24*3600 );

		if (expiryDate < today) {
			isValid = false;
		}

		if(isValid) {
			monthField.removeClass('error-message');
			yearField.removeClass('error-message');
			$("#dateExpired-error").remove();
		}

		return isValid;
	}

	function validateCVN(value) {
		var checkedType = $("input.radio-creditcard:checked");
		// Check if a saved credit cart is selected (data-cctype) or if a new credit card type is given (value)
		if( checkedType.length > 0 && 
			(
				(checkedType.data("cctype") && checkedType.data("cctype").toLowerCase() == "maestro") || 
				(checkedType.val() && checkedType.val().toLowerCase() == "maestro")
			)
		) {
			// Allow field to be empty in Maestro case.
			return /(^[\d\*]{3,4}$|^$)/.test(value);
		}
		return /^[\d\*]{3,4}$/.test(value);
	}

	function validatePositive(value) {
		if ($.trim(value).length === 0) {
			return true;
		}
		return (!isNaN(value) && Number(value) >= 0);
	}

	/*////////////////// ADDING METHODS TO VALIDATOR //////////////////*/

	/* Profile rules */

	/**
	 * Add noun validation method to jQuery validation plugin.
	 * Text fields must have 'lastName' or 'firstName' css class to be validated as name/surname fields
	 */
	$.validator.addMethod("lastName", validateNoun, app.resources.INVALID_NOUN);
	$.validator.addMethod("firstName", validateNoun, app.resources.INVALID_NOUN);

	$.validator.addMethod('birthDate', validateBirthday, app.resources.INVALID_BIRTHDATE);

	/**
	 * Add special character validation method(less restrictive) to jQuery validation plugin.
	 * Text fields must have 'specialCharAddress' css class to be validated
	 */
	$.validator.addMethod('address', validateAddress, app.resources.INVALID_ADDRESS);

	$.validator.addMethod('streetNb', validateStreetNb, app.resources.INVALID_STREETNB);

	/**
	 * Add special character validation method(less restrictive) to jQuery validation plugin.
	 * Text fields must have 'specialCharAddress' css class to be validated
	 */
	$.validator.addMethod('message', validateMessage, app.resources.INVALID_MESSAGE);

	/**
	 * Add postal code validation method to jQuery validation plugin.
	 * Text fields must have 'postal' css class to be validated as phone
	 */
	$.validator.addMethod('zip', validateZip, app.resources.INVALID_ZIP);
	$.validator.addMethod('country', validateCountry, '');

	/**
	 * adding the validation for the city field
	*/
	$.validator.addMethod('city', validateCity, app.resources.INVALID_CITY);

	/**
	 * Add phone validation method to jQuery validation plugin.
	 * Text fields must have 'phone' css class to be validated as phone
	 */
	$.validator.addMethod('phone', validatePhone, app.resources.INVALID_PHONE);

	/**
	 * Add email validation method to jQuery validation plugin.
	 * Text fields must have 'email' css class to be validated as email
	 */
	$.validator.addMethod('email', validateEmail, app.resources.INVALID_EMAIL);

	$.validator.addMethod("confirm-email", validateSameEmail, app.resources.EMAIL_NO_MATCH);

	/**
	 * Add password validation method to jQuery validation plugin.
	 * Text fields must have 'password' css class to be validated as password
	 */
	$.validator.addMethod('password-with-validation', validatePassword, app.resources.PASSWORD_LENGTH);

	$.validator.addMethod("confirm-password", validateSamePassword, app.resources.PASSWORD_NO_MATCH);

	/* Gift message field */

	// Gift fields are a special case, and there rule is added at validator init (see init() at the end of the file)
	$.validator.addMethod("gift-message", validateGiftMessage, app.resources.INVALID_GIFT_MESSAGE);

	/**
	 * Add gift cert amount validation method to jQuery validation plugin.
	 * Text fields must have 'gift-cert-amont' css class to be validated
	 */
	$.validator.addMethod("gift-cert-amount", validateGiftAmount, app.resources.GIFT_CERT_AMOUNT_INVALID);

	/* Credit card rules */

	$.validator.addMethod('valid-creditcardnumber', validateCreditCard, app.resources.CHECKOUT_PAYMENT_CARD_NUMBER);

	$.validator.addMethod('valid-cvn', validateCVN, app.resources.CHECKOUT_PAYMENT_CVN);

	$.validator.addMethod("valid-expired-date", validateExpiryDate, app.resources.CHECKOUT_PAYMENT_DATE_EXPIRED);

	/* General purpose rules */


	/**
	 * Add positive number validation method to jQuery validation plugin.
	 * Text fields must have 'positivenumber' css class to be validated as positivenumber
	 */
	$.validator.addMethod('positivenumber', validatePositive, app.resources.POSITIVE_NUMBER_NEEDED);
	
	
	$.validator.addMethod("custom-count-length", function(value, element) {	
		 
		var inputs = $(element);
	    
	    var maxcount = parseInt($(element).attr("maxlength"));
	    var maximumByte = maxcount * 1;
		var strLength = 0;
	    var cbyte = 0;
	    var limitStr = 0; 
	    var strRemoveEnmoji = '';
	    var enmojiLength = 0;
	    if(app.util.hasContainSpecialCharacter( inputs.val())){
	    	strRemoveEnmoji = inputs.val().replace(/(?:0\u20E3|1\u20E3|2\u20E3|3\u20E3|4\u20E3|5\u20E3|6\u20E3|7\u20E3|8\u20E3|9\u20E3|#\u20E3|\*\u20E3|\uD83C(?:\uDDE6\uD83C(?:\uDDE8|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDEE|\uDDF1|\uDDF2|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFC|\uDDFD|\uDDFF)|\uDDE7\uD83C(?:\uDDE6|\uDDE7|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDEF|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFB|\uDDFC|\uDDFE|\uDDFF)|\uDDE8\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF5|\uDDF7|\uDDFA|\uDDFB|\uDDFC|\uDDFD|\uDDFE|\uDDFF)|\uDDE9\uD83C(?:\uDDEA|\uDDEC|\uDDEF|\uDDF0|\uDDF2|\uDDF4|\uDDFF)|\uDDEA\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEC|\uDDED|\uDDF7|\uDDF8|\uDDF9|\uDDFA)|\uDDEB\uD83C(?:\uDDEE|\uDDEF|\uDDF0|\uDDF2|\uDDF4|\uDDF7)|\uDDEC\uD83C(?:\uDDE6|\uDDE7|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDF1|\uDDF2|\uDDF3|\uDDF5|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFC|\uDDFE)|\uDDED\uD83C(?:\uDDF0|\uDDF2|\uDDF3|\uDDF7|\uDDF9|\uDDFA)|\uDDEE\uD83C(?:\uDDE8|\uDDE9|\uDDEA|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9)|\uDDEF\uD83C(?:\uDDEA|\uDDF2|\uDDF4|\uDDF5)|\uDDF0\uD83C(?:\uDDEA|\uDDEC|\uDDED|\uDDEE|\uDDF2|\uDDF3|\uDDF5|\uDDF7|\uDDFC|\uDDFE|\uDDFF)|\uDDF1\uD83C(?:\uDDE6|\uDDE7|\uDDE8|\uDDEE|\uDDF0|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFB|\uDDFE)|\uDDF2\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF5|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFB|\uDDFC|\uDDFD|\uDDFE|\uDDFF)|\uDDF3\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEB|\uDDEC|\uDDEE|\uDDF1|\uDDF4|\uDDF5|\uDDF7|\uDDFA|\uDDFF)|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C(?:\uDDE6|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF7|\uDDF8|\uDDF9|\uDDFC|\uDDFE)|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C(?:\uDDEA|\uDDF4|\uDDF8|\uDDFA|\uDDFC)|\uDDF8\uD83C(?:\uDDE6|\uDDE7|\uDDE8|\uDDE9|\uDDEA|\uDDEC|\uDDED|\uDDEE|\uDDEF|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF7|\uDDF8|\uDDF9|\uDDFB|\uDDFD|\uDDFE|\uDDFF)|\uDDF9\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEB|\uDDEC|\uDDED|\uDDEF|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF7|\uDDF9|\uDDFB|\uDDFC|\uDDFF)|\uDDFA\uD83C(?:\uDDE6|\uDDEC|\uDDF2|\uDDF8|\uDDFE|\uDDFF)|\uDDFB\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEC|\uDDEE|\uDDF3|\uDDFA)|\uDDFC\uD83C(?:\uDDEB|\uDDF8)|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C(?:\uDDEA|\uDDF9)|\uDDFF\uD83C(?:\uDDE6|\uDDF2|\uDDFC)))|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]/g, '');
	    	enmojiLength = inputs.val().length - strRemoveEnmoji.length;
	    	
	    }else{
	    	strRemoveEnmoji = inputs.val();
	    	
	    }
	    strLength = strRemoveEnmoji.length;
	    for (var i = 0; i < strLength; i++) {
	        var ls_one_char = strRemoveEnmoji.charAt(i);
	        var encodedCharacter = encodeURIComponent(ls_one_char);
	        var encodedLength = encodedCharacter.length;
			if (encodedLength > 4) {
	            cbyte += 3; //chinese language
	        } else {
	            cbyte++; //english language
	        }
			if (cbyte <= maximumByte) {
				limitStr = i + 1;
	        }
	    }
	    var realLength = limitStr + enmojiLength;
	    
	    if(strLength > realLength){
	    	return false;
	    }

	    	return true;
	  

	}, app.resources.MAX_LIMIT_LENGTH);

	/*////////////////// OVERRIDING VALIDATOR MESSAGES //////////////////*/

	$.validator.messages.required = function ($1, ele, $3) {
		// Needed for Cross-Canal : if no data-required-text found on parents, check directly on the element
		var requiredText = $(ele).parents('.form-row').attr('data-required-text') || $(ele).data('required-text');
		return requiredText|| app.resources.VALIDATION_REQUIRED;
	};
	$.validator.messages.max = $.validator.format(app.resources.LESS_THAN_OR_EQUAL);
	$.validator.messages.min = $.validator.format(app.resources.GREATER_THAN_OR_EQUAL);
	$.validator.messages.maxlength = $.validator.format(app.resources.NO_MORE_THAN);
	$.validator.messages.email = function(ruleparams, elem){
		if( $(elem).is("input[name*='login']") ) {
			return app.resources.INVALID_LOGINEMAIL;
		}
		return app.resources.INVALID_EMAIL;
	};
	/*////////////////// VALIDATOR CONSTRUCTION //////////////////*/

	app.validator = {
		regex: regex,
		settings: settings,
		init: function () {

			$('form:not(.suppress)').each(function () {
				var data = $(this).data(),
					settings = (data && typeof data.validateSettings === 'object') ? data.validateSettings : {};
				$(this).validate($.extend({}, app.validator.settings, settings));

				//Some field need a more specific selector, so they are added after form init
				var giftField = $('.gift-message-text .input-textarea');
				if(giftField.length) {
					giftField.rules("add", {"gift-message":true});
				}

				/*var pwConfirm = $('input[id$="_passwordconfirm"]');
				if(pwConfirm.length) {
					pwConfirm.rules("add", {"confirm-password":true});
				}*/

				var cardField = $('#PaymentMethod_CREDIT_CARD .form-row input.credit-card-number');
				if(cardField.length) {
					cardField.rules("add", {"valid-creditcardnumber":true});
				}
				var cvnField = $('#single-page-payment-form .form-row.cvn input, #PaymentMethod_CREDIT_CARD .form-row.cvn input, .billing-credit-card-save .block-cvn input.cvn');
				cvnField.each(function(idx, el){
					$(el).rules('add', {
						'valid-cvn': true
					});
				});

				// Selector matches expiry date fields for Sandro (.select-row), and Maje/Claudie
				var expiredDateFields = $('#single-page-payment-form .form-row.month .select-row select, #single-page-payment-form .form-row.year .select-row select ,\
					#PaymentMethod_CREDIT_CARD .form-row.month select, #PaymentMethod_CREDIT_CARD .form-row.year select');
				if(expiredDateFields.length) {
					expiredDateFields.each(function() {
						$(this).rules('add', {
							'valid-expired-date': true
						});
					});
				}

			});

			// Trigger validation of date of birth fields
			// $('body').on("blur", 'select[id^="birthdate-"]', function(){
			// 	$('.birthDate').valid();
			// });


			////// Some js to handle change of front validation rules for Ireland on RE sites
			//////
			// In case the field is prefilled when loading the page, trigger the custom event on the fields
			// to update the validation rules.
			$(document).ready(function(){
				// $(".checkout-shipping select[id$='_country'], .addressEdit select[id$='_country']").trigger("IEchange");
			});

			// If we select Ireland on the RE website, make the zip non mandatory
			// Since the required rule is a classRule, adding or removing the class is sufficient
			// + add/remove the '*' next to the label and trigger validation of the field to reset potential errors
			$(document).on("change IEchange", ".checkout-shipping select[id$='_country'], .addressEdit select[id$='_country']", function(){
				var zipField = $(this).closest('fieldset').find('input[id$="_zip"]');
				var zipRequired = zipField.parent().find('.required-indicator');
				if($(this).val().toUpperCase() === "IE") {
					zipField.removeClass("required");
					zipRequired.text('  ');
					zipField.valid();
				} else {
					zipField.addClass("required");
					zipRequired.text('* ');
				}
			});

			// Unfortunately, the custom validation method on the zip field (as setup in the form xml)
			// is not called if the "mandatory" attribute is true and the field is empty. The field is failed immediately
			// and the custom validation is skipped.
			// So to force our validation method to be called, and correctly handle the IE special case,
			// we put something in the zip field, if it is empty, when the form is submitted.
			// The validation method then resets the contents of the field to be empty.
			$('form.checkout-shipping, #edit-address-form').on('submit', function(){
				// Only do this if the form is considered valid (meaning that empty zip fields are valid in the case of IE)
				if($(this).validate().form()) {
					$(this).find('input[id$="_zip"]').each(function(){
						if(!$(this).val() && !$(this).attr("disabled")) {
							$(this).val('N/A');
						}
					})
				}
			});

		},
		initForm: function (f) {
			$(f).validate(app.validator.settings);
		}
	};
}(window.app = window.app || {}, jQuery));